var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"info","size":"mini","loading":!_vm.skipQuery,"icon":"el-icon-download"},on:{"click":function($event){_vm.skipQuery = false}}},[_vm._v("Export Workspace")])
}
var staticRenderFns = []

export { render, staticRenderFns }